import { useCallback } from "react";
import { graphql, useMutation } from "react-relay/hooks";

import type { updateAxonIdentityProviderMutation } from "__generated__/updateAxonIdentityProviderMutation.graphql";

export const updateExistingAxonIdentityProviderMutation = graphql`
  mutation updateAxonIdentityProviderMutation($nodeId: ID!, $agencyDomain: String!) {
    updateAxonIdentityProvider(nodeId: $nodeId, agencyDomain: $agencyDomain) {
      identityProviderConfiguration {
        id
        uuid
        name
        providerType
        axonConnectDomain
      }
      errors
    }
  }
`;

export const useUpdateAxonIdentityProvider = (
  onComplete?: (response: updateAxonIdentityProviderMutation["response"]) => void,
  onError?: (error: Error) => void
) => {
  const [updateAxonIdentityProvider, loading] = useMutation<updateAxonIdentityProviderMutation>(
    updateExistingAxonIdentityProviderMutation
  );

  const callback = useCallback(
    (nodeId: string, agencyDomain: string) => {
      updateAxonIdentityProvider({
        variables: {
          nodeId,
          agencyDomain,
        },
        onCompleted: response => {
          onComplete?.(response);
        },
        onError: error => {
          onError?.(error);
        },
      });
    },
    [updateAxonIdentityProvider, onComplete, onError]
  );

  return [callback, loading] as const;
};
